module.exports = __webpack_public_path__ + "img/industry1_active.8ac720c0.png";